export default __webpack_public_path__ + "static/media/Functional_Architecture.fa931ba8.png";